import { useTranslation } from 'react-i18next';

import { NCCard, NCCard2SectionLayout, NCCardHeader } from '@/components/NCCard/NCCard';
import { SpeciesOccupancyExplainer } from '@/components/NCExplainers/SpeciesOccupancyExplainer';
import { useFact } from '@/pages/shared/projects/pages/project/pages/conservation/shared/hooks/useFact';
import { isNullish } from '@/utils/booleans';

import { GraphTile, SpeciesOccupancyData } from './components/GraphTile';
import { StatsTile } from './components/StatsTile';

const FACTS = {
  timeseries: 'r1_conservation_species_occupancy_ts',
  latest: 'r1_conservation_species_occupancy_score',
  change: 'r1_conservation_species_occupancy_change_percentage',
} as const;

export const SpeciesOccupancyCard = () => {
  const { t } = useTranslation();

  const graphFact = useFact<SpeciesOccupancyData>(FACTS.timeseries);
  const graphData = graphFact?.value;

  const latestFact = useFact<number>(FACTS.latest);
  const changeFact = useFact<number>(FACTS.change);

  const hasStatsData = !isNullish(latestFact?.value) || !isNullish(changeFact?.value);

  if (!hasStatsData && isNullish(graphData)) {
    return null;
  }

  return (
    <NCCard explainer={<SpeciesOccupancyExplainer />}>
      <NCCardHeader title={t('shared.ncaDetail.indicatorSpecies.occupancy.title')} className='lg:grid-cols-[1fr_1fr]' />
      <NCCard2SectionLayout className='[&>*]:py-8'>
        <GraphTile data={graphData} />
        <StatsTile latestFact={latestFact} changeFact={changeFact} />
      </NCCard2SectionLayout>
    </NCCard>
  );
};
